<template>
  <div style="max-height: 50vh; overflow-y: auto;">
    <template v-if="notifications && notifications.length > 0">
      <a-button
        type="link"
        v-if="isClickAllViewed"
        style="border: 0;"
        @click="updateNotifications"
        :loading="loadingBtn"
      >
        <a-icon type="check-square" /> Mark to read all
      </a-button>
      <hr class="mt-1" />

      <a-row
        v-for="n in notifications"
        :key="n.id"
        class="mb-3 noti-item"
        :style="{ color: n.isViewed ? '#ccc' : '' }"
      >
        <a href="javascript:;" @click="updateNotification(n)">
          <a-col :span="17">
            [ {{ changeNameServices(n.service) }} ]
            <strong> {{ n.title }} </strong>
            <div>
              {{ n.body }}
            </div>
          </a-col>
          <a-col :span="7">
            <a-icon type="user" />
            <strong> {{ n.author.fullname || n.author.username }} </strong
            ><br />
            <small> {{ $d(new Date(n.createdAt), "short") }} </small>
          </a-col>
        </a>
      </a-row>
    </template>
    <template v-else>
      <!-- <a-empty size="small">
        <span slot="description"> Không có thông báo mới nào! </span>
      </a-empty> -->
      <a-list item-layout="vertical" :data-source="[]" size="small"> </a-list>
    </template>
    <!-- <div v-for="n in notifications" :key="n.id">
      [ {{ changeNameServices(n.service) }} ]
      <strong>{{ n.author.fullname || n.author.username }}</strong> đã cập nhập
      <strong>{{ n.title }}</strong>
      <div>{{ n.body }}</div>
    </div> -->

    <!-- <a-list item-layout="vertical" :data-source="notifications" size="small">
      <a-list-item slot="renderItem" slot-scope="item">
        <a slot="actions">edit</a>
        <a slot="actions">more</a>
        <a-list-item-meta :description="item.body">
          <span slot="title">
            [ {{ changeNameServices(item.service) }} ]
            <strong>{{ item.title }}</strong></span
          >
        </a-list-item-meta>
        <div>content</div>
      </a-list-item>
    </a-list> -->
  </div>
</template>
<script>
import Query from "./query";
export default {
  props: {
    notifications: {
      type: Array,
      required: true,
    },
    deleteNotifications: {
      type: Function,
      default: () => {},
    },
    isClickAllViewed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loadingBtn: false,
    };
  },

  methods: {
    changeNameServices(name) {
      if (name === "approval") {
        return "Quy trình";
      } else {
        return name;
      }
    },
    updateNotification(item) {
      const [, approvalId] = item.link.split("/approval/view/");
      const routerTaskId = this.$route.params.idTask;

      // condition old  && approvalId && item.service === "approval"
      if (item) {
        const variables = {
          id: item.id,
          isClicked: true,
          isViewed: true,
        };
        // xoa noti da
        this.deleteNotifications([item]);

        // process for notification when cick
        if (!item.isClicked) {
          this.$apollo
            .mutate({
              mutation: Query.updateNotification,
              variables,
            })
            .then(({ data }) => {
              if (item.link) {
                window.open(
                  item.link,
                  "_blank" // <- This is what makes it open in a new window.
                );
              }
            })
            .catch((error) => console.log(error));
        } else {
          if (item.link) {
            window.open(
              item.link,
              "_blank" // <- This is what makes it open in a new window.
            );
          }
        }

        //   if (!item.isClicked) {
        //     this.$apollo
        //       .mutate({
        //         mutation: Query.updateNotification,
        //         variables,
        //       })
        //       .then(({ data }) => {
        //         if (data.updateNotification.id) {
        //           const routeData = this.$router.resolve(
        //             "/approval/view/" + approvalId
        //           );
        //           window.open(routeData.href, "_blank");
        //         }
        //       })
        //       .catch((error) => console.log(error));
        //   } else if (approvalId) {
        //     const routeData = this.$router.resolve(
        //       "/approval/view/" + approvalId
        //     );
        //     window.open(routeData.href, "_blank");
        //   }
        // } else if (item.itemId) {
        //   const [projectId, taskId] = item.itemId.split(":");

        //   const variables = {
        //     id: item.id,
        //     isClicked: true,
        //     isViewed: true,
        //   };

        //   this.$apollo
        //     .mutate({
        //       mutation: Query.updateNotification,
        //       variables,
        //     })
        //     .then(({ data }) => {
        //       if (data.updateNotification.id) {
        //         if (routerTaskId !== taskId) {
        //           const routeData = this.$router.resolve(
        //             "/project/" + projectId + "/" + taskId
        //           );
        //           window.open(routeData.href, "_blank");
        //         }
        //         // this.deleteNotifications([item]);
        //       }
        //     })
        //     .catch((error) => console.log(error));

        //   // this.deleteNotifications([item]);
        // } else {
        //   window.open(
        //     item.link,
        //     "_blank" // <- This is what makes it open in a new window.
        //   );
        //   // window.location.href = item.link;
      }
    },
    updateNotifications() {
      const vm = this;
      const items = this.notifications.filter((e) => !e.isViewed);
      if (items && items.length > 0) {
        this.loadingBtn = true;
        const variables = {
          ids: items.map((e) => e.id),
          isViewed: true,
        };

        this.$apollo
          .mutate({
            mutation: Query.updateNotifications,
            variables,
          })
          .then(({ data }) => {
            console.log("Đã xóa thành công!");
            this.deleteNotifications(items);
            this.loadingBtn = false;
          })
          .catch((error) => {
            console.log(error);
            this.loadingBtn = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.noti-item {
  cursor: pointer;
  padding: 5px;
}
.noti-item:hover {
  background-color: #ececec;
}
</style>
